import { GeographicEntityListPage } from '@/components/geographic/GeographicEntityListPage'
import { geographicEntities } from '@/config/geographicEntities'

export default function GeographicRegionsPage() {
  return <GeographicEntityListPage config={geographicEntities.geographicRegions} />
}
